import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const TextBlock = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* TEXT BLOCKS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Text Blocks</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Paragraph Text</label>
            <p className="text-slate-300 text-sm leading-relaxed">
              This is a standard paragraph block of text that provides information to the user. It uses proper line spacing and readability for long-form content.
            </p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<p className="text-slate-300 text-sm leading-relaxed">
  Your text here
</p>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Text with Emphasis</label>
            <p className="text-slate-300 text-sm">
              This text has <span className="font-bold text-slate-100">bold emphasis</span> and <em className="italic text-slate-200">italic styling</em> to highlight important parts.
            </p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<p className="text-slate-300">
  <span className="font-bold">bold</span> and <em className="italic">italic</em>
</p>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Multi-line Paragraph</label>
            <div className="space-y-2 text-slate-300 text-sm">
              <p>First paragraph with initial content and setup information.</p>
              <p>Second paragraph continuing the narrative with more details.</p>
              <p>Final paragraph wrapping up the discussion with conclusions.</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-2 text-slate-300">
  <p>Paragraph 1</p>
  <p>Paragraph 2</p>
  <p>Paragraph 3</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Text with Links</label>
            <p className="text-slate-300 text-sm">
              Learn more about this topic by visiting <a href="#" className="text-amber-400 hover:text-amber-300 underline">our documentation</a> or checking out <a href="#" className="text-amber-400 hover:text-amber-300 underline">the examples</a>.
            </p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<p>
  Learn more <a href="#" className="text-amber-400 underline">here</a>
</p>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">List Text</label>
            <ul className="text-slate-300 text-sm space-y-1 list-disc list-inside">
              <li>First important point goes here</li>
              <li>Second key feature to highlight</li>
              <li>Third relevant information</li>
            </ul>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<ul className="list-disc list-inside space-y-1">
  <li>Item 1</li>
  <li>Item 2</li>
  <li>Item 3</li>
</ul>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Highlighted Text Block</label>
            <div className="p-3 bg-gradient-to-r from-amber-900 to-slate-900 border-l-4 border-amber-400 rounded">
              <p className="text-slate-200 text-sm font-medium">Important Note</p>
              <p className="text-slate-300 text-sm mt-1">This text block is highlighted to draw attention to critical information.</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-3 bg-gradient-to-r from-amber-900 border-l-4">
  <p className="font-medium">Title</p>
  <p className="mt-1">Content</p>
</div>`} />
          </div>
        </div>
      </div>

      {/* SPECIAL TEXT */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Special Text Styles</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Lead Paragraph</label>
            <p className="text-slate-200 text-lg font-medium leading-relaxed mb-2">
              This is a larger lead paragraph that introduces the main topic and sets expectations for the content that follows.
            </p>
            <p className="text-slate-400 text-sm leading-relaxed">
              Regular paragraph continues with more detailed information...
            </p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<p className="text-slate-200 text-lg font-medium">
  Lead paragraph
</p>
<p className="text-slate-400 text-sm">
  Body text
</p>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Small Text / Captions</label>
            <p className="text-xs text-slate-500">
              This is small caption text typically used for disclaimers, footnotes, or less important information that provides context.
            </p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<p className="text-xs text-slate-500">
  Caption text
</p>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextBlock;


